/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_Col_TaskInputs */

const en_tasks_col_task = /** @type {(inputs: Tasks_Col_TaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Task`)
};

const pt_br2_tasks_col_task = /** @type {(inputs: Tasks_Col_TaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atividade`)
};

/**
* | output |
* | --- |
* | "Task" |
*
* @param {Tasks_Col_TaskInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const tasks_col_task = /** @type {((inputs?: Tasks_Col_TaskInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_Col_TaskInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_col_task(inputs)
	return pt_br2_tasks_col_task(inputs)
});